var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22036_200511",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H76V76H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22036_200511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6221 59.0107C13.7978 57.1864 13.7978 54.2286 15.6221 52.4043L22.4835 45.543C24.3078 43.7185 27.2656 43.7185 29.0899 45.543C30.9143 47.3672 30.9143 50.325 29.0899 52.1493L22.2285 59.0107C20.4042 60.835 17.4464 60.835 15.6221 59.0107Z",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1308 63.1211L43.7488 60.7391",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9849 57.7695L44.8188 48.6035",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5913 51.1602L51.1719 41.7408",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.731 68.9362L39.5242 69.7294C41.3485 71.5537 44.3063 71.5537 46.1307 69.7294C47.955 67.9051 47.955 64.9474 46.1307 63.1231L47.3786 64.371C49.2029 66.1953 52.1607 66.1953 53.985 64.371C55.8094 62.5467 55.8094 59.5888 53.985 57.7645L55.233 59.0125C57.0573 60.8368 60.0151 60.8368 61.8394 59.0125C63.6637 57.1881 63.6637 54.2303 61.8394 52.406L60.5916 51.1583C62.4159 52.9824 65.3736 52.9823 67.1979 51.1581C69.0221 49.3338 69.0221 46.3759 67.1979 44.5516L64.4145 41.7683",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8702 51.1551C15.0459 52.9795 12.0881 52.9795 10.2638 51.1551C8.4394 49.3308 8.4394 46.373 10.2638 44.5487L15.8772 38.9353C17.7015 37.111 20.6592 37.111 22.4835 38.9353C24.308 40.7596 24.308 43.7175 22.4835 45.5418",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.09 52.154C30.9143 50.3297 33.8721 50.3297 35.6964 52.154C37.5207 53.9784 37.5208 56.9362 35.6966 58.7605L30.0831 64.374C28.2588 66.1983 25.301 66.1983 23.4767 64.374C21.6523 62.5497 21.6523 59.5918 23.4767 57.7675",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6964 58.7575C37.5207 56.9332 40.4785 56.9332 42.3028 58.7575C44.1271 60.5818 44.1271 63.5396 42.3028 65.3639L37.9374 69.7294C36.1131 71.5537 33.1552 71.5537 31.3309 69.7294C29.5066 67.905 29.5066 64.9472 31.3309 63.1229",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45508 39.6345L12.3167 42.4961",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.039 15.341L38.0001 15.3019L37.9612 15.341L32.9804 10.3602C25.6904 3.0701 13.871 3.0701 6.5809 10.3602H6.58075C-0.522725 17.4638 -0.704413 28.8678 6.03554 36.1914",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1905 8.4603C59.8904 3.14461 49.6062 3.78022 43.0195 10.3668L38.0387 15.3477L37.9998 15.3086L37.9609 15.3477",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5535 37.0745L64.4145 41.7695L69.4194 36.7647C76.249 29.9348 76.6802 19.1295 70.713 11.7978",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6441 15.6877L27.907 25.4248C27.0375 26.2943 27.0375 27.7042 27.907 28.5737C30.6861 31.3528 35.1919 31.3528 37.9711 28.5737L44.2506 22.2941L56.0627 33.7031",
    strokeWidth: 2.22656,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "0d215b6dd7f9aef04f4c579821d73eb6.svg";
export { ForwardRef as ReactComponent };